import React from 'react';

import { video } from '../../constants';
import './Intro.css';

const Intro = () => {

  return(
    <div className="app__video">
      <video
        autoPlay
        src={video} 
        type="video/mp4"
        loop
        controls={false}
        muted
        />
    </div>
  );
}
export default Intro;
